module.exports = __webpack_public_path__ + "img/w-legal.f8ef307b.png";